<template>
  <section class="content-section primary">
    <div class="section-title">
      <!-- <div class="section-title-line"></div> -->
      <h1>KÜCHENARBEITSPLATTEN AUS NATURSTEIN</h1>
      <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Eine Küchenarbeitsplatte ist sehr hohen Belastungen ausgesetzt und sollte daher besonders widerstandsfähig sein, um den täglichen Strapazen stand halten zu können. Heutzutage findet in Küchen nicht nur aus diesem Grund ein Material immer häufiger den Einsatz, das vor Millionen von Jahren entstanden und über die Zeit gehärtet ist: Naturstein.</p>
        <hr>
        <h2>Naturstein Küchenarbeitsplatten verbinden Funktionalität und Schönheit</h2>
        <p>Naturstein-Küchenarbeitsplatten halten sehr hohe Temperaturen aus und sind besonders unempfindlich gegen Flecken, Kratzer, Wasser und Wasserdampf. Zudem sind sie besonders hygienisch und einfach zu reinigen. Doch nicht nur die besondere Robustheit und erstklassigen technischen Eigenschaften, sondern auch wegen der unverkennbaren Optik und Schönheit, erfreuen sich Naturstein-Küchenarbeitsplatten einer immer größeren Beliebtheit in modernen Küchen.</p>
        <hr>
        <div class="image-row">
          <div class="image-row-item">
            <img src="https://marmor-kunze.de/static/portfolio/arbeitsplatte/arbeitsplatte06.jpg">
          </div>
          <div class="image-row-item">
            <img src="https://marmor-kunze.de/static/images/tile-image-07.jpg">
          </div>
          <div class="image-row-item">
            <img src="https://marmor-kunze.de/static/portfolio/arbeitsplatte/arbeitsplatte01.jpg">
          </div>
        </div>
        <hr>
        <h2>Küchenarbeitsplatten aus Naturstein:
          <br>individuell, edel, natürlich und nahezu unverwüstlich
        </h2>
        <p>Als Fachbetrieb mit über 50 Jahren Erfahrung haben wir uns auf die maßgenaue Fertigung von Küchenarbeitsplatten aus verschiedenen Natursteinen und Quarzkompositen sowie Keramik spezialisiert und fertigen jede Küchenarbeitsplatte nach Ihren Wünschen und Bedürfnissen zu einem passgenauen Unikat an.
          <br>
          <br>Gerne begleiten wir Sie dabei von der Beratung zu den einzelnen Vor- und Nachteilen der verschiedenen Materialien, über das Aufmaß bis hin zur Anlieferung und dem Einbau Ihrer neuen Naturstein Küchenarbeitsplatte.
          <br>
          <br>
          <router-link :to="{ name: 'Kontakt' }">Vereinbaren Sie einfach einen Termin mit uns</router-link>oder besuchen Sie unsere Ausstellung, in der wir Ihnen ein umfangreiches Naturstein-Sortiment bereitstellen. Hier können Sie sich den Stein ansehen, anfassen und auswählen, auf dem Sie in Ihrer zukünftigen Küche arbeiten werden!
        </p>
      </article>
    </div>
    <hr>
    <div class="image-row">
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/arbeitsplatte/arbeitsplatte05.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/arbeitsplatte/arbeitsplatte02.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/arbeitsplatte/arbeitsplatte10.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/images/kueche_mosaik_01.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/images/kueche_mosaik_02.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/images/kueche_mosaik_03.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/kueche/IMG-20190125-WA0000.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/kueche/IMG-20190125-WA0001.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/kueche/IMG-20190125-WA0002.jpg">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Kuechenarbeitsplatten",
  metaInfo: {
    title: "Küchenarbeitsplatten aus Naturstein",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Als Fachbetrieb haben wir uns auf die maßgenaue Fertigung von Küchenarbeitsplatten aus verschiedenen Natursteinen und Quarzkompositen sowie Keramik spezialisiert"
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "Naturstein Küchenarbeitsplatten, Quarzkomposit Küchenarbeitsplatte, Quarzstein Küchenarbeitsplatte, Keramik Küchenarbeitsplatte, Naturstein Arbeitsplatte, Natursteinarbeitsplatte,Naturstein Arbeitsplatten Mönchengladbach"
      }
    ],
    links: [
      {
        rel: "canonical",
        href: "https://www.marmor-kunze.de/naturstein-kuechenarbeitsplatten"
      }
    ]
  }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Kuechenarbeitsplatten.vue